import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'autocompleteFilter',
    standalone: false
})
export class AutocompleteFilterPipe implements PipeTransform
{
    transform (items: any[], searchTerm: string, labelKey?: string): any
    {
        if (!items || !searchTerm)
        {
            return items;
        }

        return items.filter(
            (item: any) =>
                item[labelKey || 'label']
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()) === true
        );
    }
}
